import luminance from './luminance.js'

export default function isDark(color) {
  if (!color) {
    return false
  }

  return luminance(color) < 0.5
}
